import * as z from 'zod';
import { zEmail, zPassword } from './error-messages';

export const logInFormSchema = z.object({
  general: z.string().optional(),
  email: zEmail,
  password: zPassword,
});

export type LogInFormData = z.TypeOf<typeof logInFormSchema>;
